import { render, staticRenderFns } from "./UcPropertyGeneralData.yaml?vue&type=template&id=5607c054&component"
import script from "./UcPropertyGeneralData.yaml?vue&type=script&lang=ts&component"
export * from "./UcPropertyGeneralData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports